// extracted by mini-css-extract-plugin
export var seeAll = "_mg-0";